import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import IndianFlag from "../../../assets/icons/India.webp";
import { useAppSelector, checkUserNameExists, sendOTP, useAppDispatch, getOtpButtonVisibility } from "@hypexone/uicore";
import { SVLS_API_CLIENT } from "../../../App.utils";
import { USERNAME_REGEX } from "../Payments/commonutils";
import Button from "../../components/shared/Button/Button";
import { formInputClassName, formLabelClassName } from "../../../utils/formInputStyles";

interface StepOneProps {
  otp: number;
  otpSent: boolean;
  phoneNumber: string;
  agreedToTerms: boolean;
  username: string;
  email: string;
  password: string;
  showPassword: boolean;
  setOtp: Function;
  setPhoneNumber:any;
  onEmailChange: any;
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTermsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPasswordClickHandler: Function;
  onUsernameValidityChange: (isValid: boolean) => void;
  campaignCode: string;
  onCampaignCodeChange: (val: string) => void;
  referralCode: string;
}

const StepOne: React.FC<StepOneProps> = ({
  otp,
  otpSent,
  phoneNumber,
  agreedToTerms,
  setPhoneNumber,
  username,
  password,
  showPassword,
  setOtp,
  onEmailChange,
  onPhoneChange,
  email,
  onTermsChange,
  onUsernameChange,
  onPasswordChange,
  showPasswordClickHandler,
  onUsernameValidityChange,
  campaignCode,
  onCampaignCodeChange,
  referralCode,
}) => {
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const [errorMsg, setErrorMsg] = useState<string>();
  const [otpTimer, setOtpTimer] = useState<number>();
  const [usernameSeleted, setUsernameSelected] = useState<boolean>(false);
  const checkUserExists = async (user: string) => {
    setUsernameSelected(true);
    let valid = true;
    if (user?.length < 4) {
      setErrorMsg("Username must have at least 4 characters");
      return;
    } else if (!USERNAME_REGEX.test(user)) {
      setErrorMsg("Invalid username format");
      return;
    }
    let res = await checkUserNameExists(SVLS_API_CLIENT, user?.toLowerCase());
    if (res === true) {
      setErrorMsg("Username already exists");
      valid = false;
    } else {
      setErrorMsg("");
      valid = true;
    }
    onUsernameValidityChange(valid);
  };
  useEffect(() => {
    if (usernameSeleted) {
      checkUserExists(username);
    }
    else {
      onUsernameValidityChange(false);
    }
  }, [username]);
    useEffect(()=>{
    if(otpSent) {
      handleOtpTimer(60);
    }
  },[otpSent]);
    const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };
  const otpChannelBlocked =
    otpTimer !== undefined && otpTimer !== null && otpTimer >= 0;

  const { showSmsOtpButton, showWhatsappOtpButton, showGenericOtpButton } =
    getOtpButtonVisibility(domainConfig);

  const requestPhoneOtp = (isWhatsapp: boolean) => {
    if (otpChannelBlocked || !phoneNumber) return;
    dispatch(sendOTP({ phoneNumber: "91" + phoneNumber, isWhatsapp }));
    handleOtpTimer(60);
  };
  const inputClassName = formInputClassName;
  const labelClassName = formLabelClassName;

  return (
    <div className="flex flex-col gap-1.5 sm:gap-2">
      <div className="shrink-0">
        <div className="flex gap-2 font-bold text-black-900 text-opacity-60">
          <div className="flex h-8 w-[68px] shrink-0 items-center rounded-md border border-solid border-bg-grey p-[2px] text-white sm:h-10 sm:w-[80px]">
            <img src={IndianFlag} alt="" className="h-4 w-4 object-contain" />
            <div className="text-xs sm:text-sm">+91</div>
            <IoMdArrowDropdown className="text-sm" />
          </div>
          <input
            type="tel"
            id="phoneNumber"
            className={inputClassName}
            placeholder={langData?.["enter_phone_number_txt"]}
            value={phoneNumber}
            onChange={onPhoneChange}
            maxLength={10}
          />
        </div>
        {(showSmsOtpButton || showWhatsappOtpButton || showGenericOtpButton) &&
          !otpSent && (
          <div className="mt-1.5 flex gap-2">
            {(showSmsOtpButton || showGenericOtpButton) && (
              <Button
                type="button"
                className={`${showWhatsappOtpButton ? "flex-1" : "w-full"} rounded-md bg-[#64748B] px-2 py-1.5 text-xs text-white sm:py-2 sm:text-sm`}
                onClick={() => requestPhoneOtp(false)}
                disabled={phoneNumber?.length < 10 || otpChannelBlocked || !!errorMsg}
              >
                {showGenericOtpButton
                  ? langData?.["send_otp"] ?? "Send OTP"
                  : langData?.["get_otp"] ?? "SMS OTP"}
              </Button>
            )}
            {showWhatsappOtpButton && (
              <Button
                type="button"
                className={`${showSmsOtpButton || showGenericOtpButton ? "flex-1" : "w-full"} rounded-md bg-[#0d9488] px-2 py-1.5 text-xs text-white sm:py-2 sm:text-sm`}
                onClick={() => requestPhoneOtp(true)}
                disabled={phoneNumber?.length < 10 || otpChannelBlocked || !!errorMsg}
              >
                {langData?.["get_otp_whatsapp"] ?? "WhatsApp OTP"}
              </Button>
            )}
          </div>
        )}
      </div>

      <div className="flex shrink-0 items-start gap-2">
        <input
          type="checkbox"
          id="termsAgreement"
          className="mt-0.5 h-4 w-4 shrink-0 rounded bg-white sm:h-5 sm:w-5"
          checked={agreedToTerms}
          onChange={onTermsChange}
        />
        <label
          htmlFor="termsAgreement"
          className="text-[11px] leading-snug text-white sm:text-xs"
        >
          {langData?.["terms_and_conditions_txt"]}
        </label>
      </div>

      <div className="grid grid-cols-1 content-start items-start gap-1 sm:gap-1.5 md:grid-cols-2 md:gap-x-3 md:gap-y-2">
        <div className="flex w-full flex-col gap-0">
          <label htmlFor="username" className={labelClassName}>
            {langData?.["username"]}
          </label>
          <input
            type="text"
            id="username"
            className={inputClassName}
            placeholder={langData?.["enter_username_txt"]}
            value={username}
            onBlur={(e) => checkUserExists(e.target.value)}
            onChange={onUsernameChange}
          />
          {errorMsg && (
            <div className="text-[10px] leading-tight text-red-400 sm:text-xs">
              {errorMsg}
            </div>
          )}
        </div>

        <div className="flex w-full flex-col gap-0">
          <label htmlFor="password" className={labelClassName}>
            {langData?.["password"]}
          </label>
          <div className={`${inputClassName} gap-2`}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              className="w-full border-none bg-transparent text-sm focus:outline-none"
              placeholder={langData?.["enter_password"]}
              value={password}
              onChange={onPasswordChange}
            />
            <button
              type="button"
              className="shrink-0 cursor-pointer text-sm"
              onClick={() => showPasswordClickHandler()}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </button>
          </div>
        </div>

        <div className="flex w-full flex-col gap-0 md:col-span-2">
          <label htmlFor="campaignCode" className={labelClassName}>
            {langData?.["campaign_code"] || "Campaign Code"}
          </label>
          <input
            type="text"
            id="campaignCode"
            className={inputClassName}
            placeholder={
              langData?.["enter_campaign_code"] ?? "Enter Campaign Code"
            }
            value={campaignCode}
            onChange={(e) => onCampaignCodeChange(e.target.value)}
          />
        </div>

        {referralCode && (
          <div className="flex w-full flex-col gap-0 md:col-span-2">
            <label htmlFor="referralCode" className="self-start text-white font-bold">
              {langData?.["referral_code"] ?? "Referral Code"}
            </label>
            <input
              type="text"
              id="referralCode"
              readOnly
              className={`${inputClassName} !text-gray-900/40`}
              value={referralCode}
            />
          </div>
        )}

        {otpSent && (
          <div className="flex w-full flex-col gap-0 md:col-span-2">
            <label htmlFor="otp" className={labelClassName}>
              {langData?.["otp"]} *
            </label>
            <input
              type="tel"
              id="otp"
              className={inputClassName}
              placeholder={langData?.["enter_otp_txt"]}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            {(showSmsOtpButton || showWhatsappOtpButton || showGenericOtpButton) && (
              <div className="mt-0.5">
                {otpChannelBlocked ? (
                  <div className="text-[11px] text-white sm:text-xs">
                    {`${langData?.["resend_in_txt"]} ${otpTimer} ${langData?.["seconds"]}`}
                  </div>
                ) : (
                  <div className="flex gap-2">
                    {(showSmsOtpButton || showGenericOtpButton) && (
                      <Button
                        type="button"
                        className={`${showWhatsappOtpButton ? "flex-1" : "w-full"} rounded-md bg-blue-500 px-2 py-1.5 text-xs text-white hover:bg-blue-600 sm:py-2 sm:text-sm`}
                        onClick={() => requestPhoneOtp(false)}
                        disabled={phoneNumber?.length < 9 || !!errorMsg}
                      >
                        {showGenericOtpButton
                          ? langData?.["send_otp"] ?? "Send OTP"
                          : langData?.["resend_sms_otp"] ?? "Resend SMS OTP"}
                      </Button>
                    )}
                    {showWhatsappOtpButton && (
                      <Button
                        type="button"
                        className={`${showSmsOtpButton || showGenericOtpButton ? "flex-1" : "w-full"} rounded-md bg-teal-600 px-2 py-1.5 text-xs text-white hover:bg-teal-700 sm:py-2 sm:text-sm`}
                        onClick={() => requestPhoneOtp(true)}
                        disabled={phoneNumber?.length < 9 || !!errorMsg}
                      >
                        {langData?.["resend_whatsapp_otp"] ?? "Resend WhatsApp OTP"}
                      </Button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StepOne;
